export default {
  unauthHome: [
    {
      key: 1,
      name: "Login",
      component: {
        type: "a",
        href: process.env.GATSBY_PORTAL_SIGNIN_LINK,
      },
    },
    {
      key: 2,
      name: "Register Now!",
      component: {
        type: "a",
        func: "openModal",
      },
      mobileOnly: true,
    },
  ],
  authHome: [
    {
      key: 3,
      name: "Logout",
      component: {
        type: "a",
        href: process.env.GATSBY_API_LOGOUT,
      },
    },
  ],
  unLoggedInClinicians: [
    {
      key: 4,
      name: "Benefits",
      url: "/Clinicians/",
    },
    {
      key: 5,
      name: "Trainings",
      url: "/Clinicians/Trainings/",
    },
    {
      key: 6,
      name: "Resources",
      url: "/Clinicians/Resources/",
    },
    {
      key: 7,
      name: "Products",
      url: "/Clinicians/Products/",
    },
    {
      key: 8,
      name: "Sign In",
      component: {
        type: "a",
        href: process.env.GATSBY_PORTAL_SIGNIN_LINK,
      },
      mobileOnly: true,
    },
  ],
  loggedInClinicians: [
    {
      key: 9,
      name: "Resources",
      url: "/Clinicians/Resources/",
    },
    {
      key: 10,
      name: "Trainings",
      url: "/Clinicians/Trainings/",
    },
    {
      key: 11,
      name: "Products",
      url: "/Clinicians/Products/",
    },
    {
      key: 12,
      name: "Logout",
      component: {
        type: "a",
        func: "logout",
      },
      mobileOnly: true,
    },
  ],
  patients: [
    {
      key: 13,
      name: "Benefits",
      url: "/Patients/",
    },
  ],
}
